import axios from "axios";
import {environmentConfig} from "../config/environmentConfig";

export default class ZambiaIntegrationService {
    static async subscribe(msisdn, subscriptionPackage, campaignId, trackerId = null, publisherId = null) {
        try {
            return axios.post(`${environmentConfig.zmbIntegrationHost}/subscribe`, {msisdn: msisdn, subscriptionPackage: subscriptionPackage, campaignId: campaignId, trackerId: trackerId, publisherId: publisherId});
        }
        catch(error){
            console.log(`Error Occurred`);
        }
    }

    static async getUserViaMsisdn(msisdn) {
        try {
            return await axios.post(`${environmentConfig.zmbIntegrationHost}/user/get-user`, {msisdn: msisdn});
        }
        catch(error){
            console.log(`Error Occurred`);
        }
    }
}
